// import Image from "next/image";
// import { Images } from "@/assets/assets";

export default function FollowUs() {
	return (
		<div className="contact-col">
			<ul className="list-unstyled social-links d-flex">
				{/* <li><a className="d-flex justify-content-center align-items-center w-100 h-100" href="https://www.facebook.com" target="_blank"><Image className="img-fluid" src={Images.iconFacebook} alt="icon" /></a></li>
				<li><a className="d-flex justify-content-center align-items-center w-100 h-100" href="https://www.linkedin.com" target="_blank"><Image className="img-fluid" src={Images.iconLinkedin} alt="icon" /></a></li>
				<li><a className="d-flex justify-content-center align-items-center w-100 h-100" href="https://www.linkedin.com" target="_blank"><Image className="img-fluid" src={Images.iconTwiter} alt="icon" /></a></li>
				<li><a className="d-flex justify-content-center align-items-center w-100 h-100" href="https://www.pinterest.com" target="_blank"><Image className="img-fluid" src={Images.iconPinterest} alt="icon" /></a></li>
				<li><a className="d-flex justify-content-center align-items-center w-100 h-100" href="https://www.youtube.com" target="_blank"><Image className="img-fluid" src={Images.iconYoutube} alt="icon" /></a></li> */}
			</ul>
		</div>
	)
}